"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateSurveyAssetTranslationMappingRequestToJSON = exports.CreateSurveyAssetTranslationMappingRequestFromJSONTyped = exports.CreateSurveyAssetTranslationMappingRequestFromJSON = exports.instanceOfCreateSurveyAssetTranslationMappingRequest = void 0;
/**
 * Check if a given object implements the CreateSurveyAssetTranslationMappingRequest interface.
 */
function instanceOfCreateSurveyAssetTranslationMappingRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "languageCode" in value;
    isInstance = isInstance && "audioAssetId" in value;
    isInstance = isInstance && "logoAssetId" in value;
    isInstance = isInstance && "companionAssetId" in value;
    isInstance = isInstance && "brandName" in value;
    isInstance = isInstance && "transparencyLink" in value;
    isInstance = isInstance && "transparencyLinkText" in value;
    return isInstance;
}
exports.instanceOfCreateSurveyAssetTranslationMappingRequest = instanceOfCreateSurveyAssetTranslationMappingRequest;
function CreateSurveyAssetTranslationMappingRequestFromJSON(json) {
    return CreateSurveyAssetTranslationMappingRequestFromJSONTyped(json, false);
}
exports.CreateSurveyAssetTranslationMappingRequestFromJSON = CreateSurveyAssetTranslationMappingRequestFromJSON;
function CreateSurveyAssetTranslationMappingRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'languageCode': json['language_code'],
        'audioAssetId': json['audio_asset_id'],
        'logoAssetId': json['logo_asset_id'],
        'companionAssetId': json['companion_asset_id'],
        'brandName': json['brand_name'],
        'transparencyLink': json['transparency_link'],
        'transparencyLinkText': json['transparency_link_text'],
    };
}
exports.CreateSurveyAssetTranslationMappingRequestFromJSONTyped = CreateSurveyAssetTranslationMappingRequestFromJSONTyped;
function CreateSurveyAssetTranslationMappingRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'language_code': value.languageCode,
        'audio_asset_id': value.audioAssetId,
        'logo_asset_id': value.logoAssetId,
        'companion_asset_id': value.companionAssetId,
        'brand_name': value.brandName,
        'transparency_link': value.transparencyLink,
        'transparency_link_text': value.transparencyLinkText,
    };
}
exports.CreateSurveyAssetTranslationMappingRequestToJSON = CreateSurveyAssetTranslationMappingRequestToJSON;
